import './utils/classComponentHook';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from '@/utils/i18n';

import { initBackendUrl, initDependencies, initIcons, initSessionHandling } from '@/utils/init';

Vue.config.productionTip = false;

initDependencies();
initIcons();
initBackendUrl();
initSessionHandling(router, store);

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels, ArcElement);

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
